import { OutboundLink } from "gatsby-plugin-google-analytics";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default {
  OutboundLink,
  React,
  MDXTag
};